import { Component, h, Host, Element, Prop, Listen } from '@stencil/core';

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

@Component({
  tag: 'lilu-hero-slider',
  styleUrl: 'lilu-hero-slider.scss',
  shadow: false,
})
export class LiluHeroSlider {

  @Prop() swiper: any;
  @Element() el: HTMLElement;

  isHovered = false;
  currentSlideType: 'image' | 'video';

  @Listen('mouseenter')
  mouseEnter() {
    this.isHovered = true;
    if (this.currentSlideType === 'image') {
      this.swiper.autoplay.stop();
    }
  }

  @Listen('mouseleave')
  mouseLeave() {
    this.isHovered = false;
    if (this.currentSlideType === 'image') {
      this.swiper.autoplay.start();
    }
  }

  componentDidLoad() {
    const contentWrapper = this.el.getElementsByClassName("swiper-wrapper");
    if(contentWrapper[0].children.length > 1){
      // let self = this;
      this.swiper = new Swiper('.swiper-hero', {
        modules: [
          Navigation,
          Pagination,
          Autoplay,
        ],
        loop: true,
        speed: 400,
        preloadImages: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        simulateTouch: true,
        pagination: {
          el: ".swiper-hero-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        noSwipingClass: 'swiper-no-swiping',
        autoplay: {
          delay: 4400, // Wait 4000 my per slide and calculate in the speed per transition of 400ms
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        threshold: 5,
      });
      this.swiper.on('slideChange', () => this.handleSlide());

      // Executes the slide handling for first slide, afterwards will be handeled by the slideChange event
      this.handleSlide();
    }else{
      const navigation = this.el.getElementsByClassName("swiper-navigation");
      navigation[0].remove();
      this.el.querySelector('video')?.setAttribute('loop', '');
    }
  }

  handleSlide() {
    this.removeVideoEndedHandler(); // Video event cleanup
    const currentSlide = this.el.querySelectorAll('.swiper-slide')[this.swiper.activeIndex];

    if (currentSlide.getAttribute('imageorvideo') === 'video') {
      this.currentSlideType = 'video';
      this.swiper.autoplay.stop();
      let video = currentSlide.querySelector('video');

      video.play();

      // Register event on the video to get noticed when it's finished
      const endedHandler = () => this.handleVideoEnded(video);
      video.addEventListener('ended', endedHandler);

      // Store the event listener reference on the video element so it can be removed later
      // Prevents events from video which are not visible and multiple registered events on the same element
      (video as any).endedHandler = endedHandler;

    } else {
      this.currentSlideType = 'image';
      if (!this.isHovered) {
        this.swiper.autoplay.start();
      }
    }
  }

  // Find all videos in the slider and removes the ended events from the saved event listener
  removeVideoEndedHandler() {
    const videoSlides = this.el.querySelectorAll('.swiper-slide[imageOrVideo="video"]')
    videoSlides?.forEach(videoSlide => {
      const video: any = videoSlide.querySelector('video');
      video.removeEventListener('ended', video.endedHandler);
    });
  }

  handleVideoEnded(video) {
    if (this.isHovered) {
      // While mouse is hovering the slider the video should loop
      video.play();
    } else {
      this.swiper.slideNext();
    }
  }

  render() {
    return (
      <Host>
        <div class="swiper-hero white">
          <div class="swiper-wrapper">
            <slot></slot>
          </div>
          <div class="swiper-area"></div>
          <div class="swiper-hero-pagination"></div>
          <div class="swiper-navigation">
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
      </Host>
    );
  }
}
